import { createMuiTheme } from '@material-ui/core/styles'
import { grey, red } from '@material-ui/core/colors'

const defaultTheme = createMuiTheme({
  typography: {
    fontFamily: ['MontrealRegular'].join(',')
  },
  palette: {
    primary: grey,
    secondary: red
  },
  overrides: {
    MuiAppBar: {
      colorPrimary: '#FFFFFF'
    }
  }
})
export default defaultTheme
